module.exports = __webpack_public_path__ + "static/02-f2bca1d09be4364ada8c59fff5d54d6f.jpg";